import React, { Component } from 'react';
import { connect } from 'react-redux';
import { cambiarStringApp } from '../../actions';
import { Redirect } from 'react-router-dom';
// import history from '../../history';

// Redirect
// Rendering a <Redirect> will navigate to a new location. The new location will override the current location in the history stack, like server-side redirects (HTTP 3xx) do
// History
// push function Pushes a new entry onto the history stack
class RedirIdioma extends Component {
  constructor(props) {
    super(props);

    // if (props.idioma === 'es') { history.push('/es/'); } else { history.push('/es/'); }

    props.cambiarStringApp('render_header', false);
    props.cambiarStringApp('render_descubre', false);
    props.cambiarStringApp('render_footer', false);

    props.cambiarStringApp('menuVisible', false);
    setTimeout(() => { window.scrollTo(0, 0); }, 250);
  }

  componentWillUnmount() {
    this.props.cambiarStringApp('render_header', true);
    this.props.cambiarStringApp('render_descubre', true);
    this.props.cambiarStringApp('render_footer', true);
  }

  render() {
    return <Redirect to={`/${this.props.idioma}/`} />;
  }
}

const mapStateToProps = ({ app }) => {
  const { idioma } = app;

  return { idioma };
};

export default connect(mapStateToProps, { cambiarStringApp })(RedirIdioma);
